import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IProductos } from '../../../../private/shared/models/productos';
import { SegmentItem } from '../../atoms';
import { environment } from './../../../../../environments/environment';

@Component({
  selector: 'getm-product-card-v2',
  templateUrl: './product-card-v2.component.html',
  styleUrls: ['./product-card-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardV2Component implements OnInit {

  @Input() product: IProductos = {} as IProductos;
  @Input() recommender: number = 0;

  @Output() quantityChange = new EventEmitter<IProductos>();
  @Output() productClick = new EventEmitter<IProductos>();

  public isProd = environment.production;
  public segment: SegmentItem = { id: 0, title: '', subtitle: '', active: true, icon: '', color: '' };
  public segmentsGetmEcommerce: SegmentItem[] = [];

  constructor(
    private translateS: TranslateService
  ) {
    this.segmentsGetmEcommerce = this.translateS.instant('Segments.GetmEcommerce').filter((segment: SegmentItem) => segment.active);
  }

  ngOnInit() {
    const rcmdr = this.segmentsGetmEcommerce.filter(segment => segment.id === this.recommender);
    this.segment = rcmdr.length > 0 ? rcmdr[0] : this.segment;
  }

  public onProductClick = (): void => {
    this.productClick.emit(this.product);
  }

  public onQuantityChange = (quantity: number) => {
    this.product = { ...this.product, productos: quantity };
    this.quantityChange.emit(this.product);
  }

  public onRemoveProduct = () => {
    this.product = { ...this.product, productos: 0 };
    this.quantityChange.emit(this.product);
  }
}
